export default __webpack_public_path__ + "static/media/menu_logo.1d2edb4f.svg";